import React, {Component} from "react";
import BilateralLoanLogHistory from "./BilateralLoanLogHistoryView";
import {BILATERAL_CONTROL_PANEL_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import PropTypes from "prop-types";
import {BilateralLoanService} from "../../../../service/bilateral/loan/BilateralLoanService";

export default class BilateralLoanLogHistoryContainer extends Component {
    constructor(props) {
        super(props);

        this.bilateralLoanService = new BilateralLoanService();
        this.loading = this.loading.bind(this);
        this.closeButton = this.closeButton.bind(this);
        this.getLoanHistory = this.getLoanHistory.bind(this);

        this.state = {
            isLoading: true,
            loanId: this.props.location.state.selectedLoanControlPanel.id,
            loanHistory: [],
        };
    };

    componentDidMount() {
        let loanId = this.props.location.state.selectedLoanControlPanel.id;
        this.getLoanHistory(loanId);
    }

    getLoanHistory(loanId){
        this.bilateralLoanService.getLoanLogHistory(loanId)
            .then( res => {
                if (this.validResponse(res)){
                    this.setState({
                        loanHistory: res.data,
                    });
                }
                this.loading(false);
            });
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }


    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    closeButton() {
        this.props.history.push({
            pathname: BILATERAL_CONTROL_PANEL_ROUTE,
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <BilateralLoanLogHistory
            isLoading={this.state.isLoading}
            loanHistory={this.state.loanHistory}
            loanId={this.state.loanId}
            messagesGrowl={messagesGrowl}
            closeButton={this.closeButton}
        />

    }
};

BilateralLoanLogHistoryContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};